<template>
  <div>

    <div id="modalLog" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Logs Mensajes Referencias</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <table class="table">
                <thead>
                    <tr>
                        <th>Fecha Envío</th>
                        <th>Servicio Mensajería</th>
                        <th>Email</th>
                        <th>Teléfono</th>
                        <th>Status</th>
                        <th>Tipo de Mensaje</th>
                    </tr>
                </thead>
                <tbody>
                      <tr v-for="reference_event in message_logs" :key="reference_event.id">
                        <td>{{ formatDate(reference_event.created_at) }}</td>
                        <td>{{ reference_event.category }}</td>
                        <td>{{ reference.email }}</td>
                        <td>{{ reference.contact_telephone }}</td>
                        <td>
                          <span style="padding: 1%;" v-if="reference_event.delivery_status == 'delivered'" class="alert alert-success">
                            Enviado
                          </span>
                          <span style="padding: 1%;" v-else class="alert alert-danger">
                            No enviado
                          </span>

                        </td>
                        <td>{{ reference_log_message_type(reference_event.attempt) }} </td>
                      </tr>
                </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-info" data-dismiss="modal">Cerrar</button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment'

  export default {
    name: 'ModalLog',
    props: ['eventable'],
    computed: {
    },
    data() {
      return {
        reference: null,
        message_logs: null
      }
    },
    methods: {

      formatDate: function(value) {
        if (value != null) {
          let date = new Date(value);
          date = date.setHours(date.getHours() - 5)
          return moment(date).format('MM/DD/YYYY hh:mm')
        } else {
          return 'Sin fecha'
        }
      },

      reference_log_message_type(attempt){
        if (attempt == 0) {
          return "Mensaje original"
        } else if (attempt == 1) {
         return  "Mensaje original reenviado"
        } else if (attempt == 2) {
          return "Mensaje recordatorio"
        }
      },

      async getReferenceLogs() {
        let request
        try {
          request = await axios.get(`/api/v1/${this.eventable.id}/message_logs`)
          this.reference = request.data.data.reference
          this.message_logs = request.data.data.message_logs
          } catch (error) {
            console.log(error);
          }
        }
      },
    watch: {
      eventable() {
        this.getReferenceLogs()
      }
    },
    filters: {

    }
  }
</script>
